export default {
  activeTab: 'team',
  lastUpdatedTime: '',
  /* line預約單總數*/
  lineReserveTotal: 0,
  /* radio的task選項 => 顯示全部(all)、未配對訂單(nonAssign)、預約內一小時(limitTime) 、Line網路預約tab(internet) */
  task: 'nonAssign',
  sort: 'createdAt',
  sortStatus: 'desc',
  // nonAssignTotal: null,
  // nonReplyTotal: null,
  currentStatus: null,
  recentTotal: 0, //顯示最近訂單的數量
  nonmatchTotal: 0, //未配對訂單的數量
  reserveTotal: 0, //預約一小時訂單的數量
  /* radio的rule選項 => 0:查全部、1:只查呼號、2:只查電話 */
  rule: 0,
  /* 車隊專屬預約單 */
  teamList: [],
  teamPaging: {
    currentPage: 1,
    npp: 25,
    totalPages: 1,
    totalEntries: null,
  },
  /* Line網路預約 */
  lineList: [],
  linePaging: {
    currentPage: 1,
    npp: 25,
    totalPages: 1,
    totalEntries: null,
  },
  /* 機場預約 */
  airportList: [],
  airportPaging: {
    currentPage: 1,
    npp: 25,
    totalPages: 1,
    totalEntries: null,
  },
  /* 訂單詳細資訊modal */
  modalId: null,
  modal: {
    billInfo: {
      orderId: '',
      reservationType: 0,
      reservationTime: '',
      onLocation: '',
      offLocation: '',
      passengerOnLacatioNote: '',
      passengerNote: '',
      result: '',
      call_method: '',
      passengerCancel: '',
      driverCancel: '',
      passengerPhone: '',
      passengerName: '',
      actualFare: null,
      pickUpPassengerTime: null,
      finishTime: null,
    },
    managerInfo: {
      name: '',
    },
    serviceInfo: {
      name: '',
    },
    passengerInfo: {
      phone: '',
      name: '',
    },
    driverInfo: {
      isReply: false,
      teamName: '',
      phone: '',
      callNumber: '',
    },
    billInfo: {
      passengerNote: '',
    },
  },
}



// WEBPACK FOOTER //
// ./src/store/reservation/state.js